/**
 * https://mui.com/material-ui/customization/breakpoints/
 * Using the theme breakpoints,
 * careful with updates, it can break the ui
 */
export const VIEWPORT = {
  mobile: '600px',
  tablet: '900px',
};
